import { DimensionType } from '@constants/common';

export const COMPRESSION_LEVEL = 9;
export const MASTER_JSON_VERSION = 'v2';
export const BLANK_TEMPLATE_ID = 10456;
export const BLOCKLINE_THUMBNAIL = 'BLOCKLINE_THUMBNAIL';
export const disableDuplicateSubTypes = [
  'startclip_block',
  'endclip_block',
  'hidden_block_composite',
];
export const disableRemoveDuplicateSubTypes = [
  'persistent_logo',
  'logo_composite',
];
export const REFRESH_EXPORTING_PROJECTS_CALL_DURATION = 30 * 1000;

function redirectToEditor(
  masterId: string,
  dimension: string,
  templateId: string,
  isStoryboard: boolean,
  type?: string,
  workflow?: string,
  loader?: string,
  isBlankCanvas = false,
) {
  let url = getEditorRedirectionUrl(
    masterId,
    dimension,
    templateId,
    isStoryboard,
    type,
    workflow,
    loader,
    isBlankCanvas,
  );
  window.open(url, '_self');
}

export const getEditorRedirectionUrl = (
  masterId: string,
  dimension: string,
  templateId: string,
  isStoryboard: boolean,
  type?: string,
  workflow?: string,
  loader?: string,
  isBlankCanvas = false,
) => {
  let url = '';

  if (isBlankCanvas) {
    url = `/editor?id=${templateId}&dimension=${dimension}&cacheRefresh=true&resize=true`;
  } else if (isStoryboard) {
    url = `/storyboard?video_id=${masterId}&dimension=${dimension}&id=${templateId}&cacheRefresh=true&resize=true`;
  } else {
    url = `/editor?video_id=${masterId}&dimension=${dimension}&id=${templateId}&cacheRefresh=true&resize=true`;
  }

  if (type) {
    url += `&type=${type}`;
  }

  if (workflow) {
    url += `&workflow=${workflow}`;
  }

  if (loader) {
    url += `&loader=${loader}`;
  }
  return url;
};

export const createBlankProject = (dimension: DimensionType) => {
  const blankTemplateId = String(BLANK_TEMPLATE_ID);
  // selectTemplateAnalyticsEvent(null, 'Blank', dimension);
  redirectToEditor(
    '',
    dimension,
    blankTemplateId,
    false,
    'all',
    'story',
    'oneClick',
    true,
  );
};

export default redirectToEditor;
